

export const state = {
  title: '',
}

export const mutations = {
  setTitle (currentState, title) {
    currentState.navbar.title = title
  },
}

export const actions = {
  setTitle ({ commit }, title) {
    commit('setTitle', title)
  },
}
export default {
  state, actions, mutations,
}
